import { IconButton } from "@dropbox/dig-components/buttons";
import React, { useCallback, useEffect, useRef } from "react";

import { UIIcon } from "@dropbox/dig-icons";
import { CloseLine } from "@dropbox/dig-icons/assets";
import { StackPageChatSidebar } from "@mirage/mosaics/ConversationAssistant/containers/StackPageChatSidebar";
import i18n from "@mirage/translations";
import classNames from "classnames";
import { useSetAtom } from "jotai";
import { stackChatSidebarOpenAtom } from "../atoms/chatSidebarAtoms";
import { useStackChatSources } from "../hooks/FullScreenStackHooks";
import { useShowDashChatSidebar } from "../hooks/useShowDashChatSidebar";
import { useLoadDashStackChat } from "../hooks/useStackChat";
import styles from "./ChatSidebar.module.css";

export const ChatSidebar: React.FC = () => {
  const hasSentInitialStackChatMessage = useRef(false);
  const loadDashStackChat = useLoadDashStackChat();
  const { hasChatSources, chatSources } = useStackChatSources();
  const setStackChatSidebarOpen = useSetAtom(stackChatSidebarOpenAtom);
  const showDashChatSidebar = useShowDashChatSidebar();

  useEffect(() => {
    if (!hasChatSources || hasSentInitialStackChatMessage.current) {
      return;
    }
    hasSentInitialStackChatMessage.current = true;
    loadDashStackChat();
  }, [hasChatSources, chatSources, loadDashStackChat]);

  const onClose = useCallback(() => {
    setStackChatSidebarOpen(false);
  }, [setStackChatSidebarOpen]);

  return (
    <div
      className={classNames(styles.sidebarContainer, {
        [styles.sidebarContainerHidden]: !showDashChatSidebar,
      })}
    >
      <div role="separator" aria-orientation="vertical" />
      <div className={styles.actionOverlayContainer}>
        <IconButton onClick={onClose} variant="transparent">
          <UIIcon aria-label={i18n.t("close_sidebar_aria")} src={CloseLine} />
        </IconButton>
      </div>
      <StackPageChatSidebar />
    </div>
  );
};
